export const ERA_FLAVORS = [
  'Age of Gold',
  'Age of Heroes',
  'Age of Kings',
  'Age of Shadow',
  'Age of War',
  'Age of Ruin',
  'Age of Awakening',
  'Age of Myth',
  'Age of Iron',
  'Custom'
];
